var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWistia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    viewBox: "0 0 36 34",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wistia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    strokeWidth: 3,
    d: "m16.2 23h-5.1c-1.6 0-3.1.4-4.2 1.6l-6.7 7.7c4.9.3 10 .3 13.6.3 18.3 0 21.2-11 21.3-16.5-1.6 2-6.4 6.9-18.9 6.9zm16.6-17.7c-.1.9-.6 4.8-11.6 4.8-8.9 0-12.5 0-21.3-.2l6.6 7.6c1.3 1.5 3.1 2 5.1 2.1 2.2 0 5.2.1 5.6.1 12.3 0 17.5-5.7 17.5-9.8.1-2.2-.6-3.6-1.9-4.6z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWistia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/wistia.a4ffad6862d6fc3673b62a82c499e9eb.svg";